import {h, Fragment} from "preact"
import { SerpElement, useCurrencyFormatting } from "@nosto/preact"
import { productImagePlaceholder } from "../helpers"
import { useState } from 'preact/hooks'

export default function Product({ product, facets }) {
    const { format } = useCurrencyFormatting();
    const [currentImage, setCurrentImage] = useState(product.imageUrl);

    const tags = (() => {
        const badgeTag = product.tags1?.find(tag => tag.toLowerCase().includes('badge'));
        if (!badgeTag) return [];
        
        const tagTitle = badgeTag.split('::')[1]?.toUpperCase() || '';
        return [{
            label: tagTitle,
            class: "Eyebrow-C"
        }];
    })();

    const hasVariants = product.skus && product.skus.length > 1;
    const [name, subheading] = product.name.split(' - ');

    return (
        <div class="card-wrapper product-card-wrapper">
            <SerpElement
                as="a"
                hit={product}
                class="card"
            >
                <div class="card__inner card__inner-new">
                    <div class="card__media card__media-new">
                        <div class="media media--hover-effect">
                            <img
                                srcset={`${currentImage}?width=165 165w,
                                        ${currentImage}?width=360 360w,
                                        ${currentImage}?width=533 533w,
                                        ${currentImage}?width=720 720w,
                                        ${currentImage}?width=940 940w,
                                        ${currentImage}?width=1066 1066w,
                                        ${currentImage} 1600w`}
                                src={`${currentImage}?width=533`}
                                sizes="(min-width: 1920px) 447px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"
                                alt={product.name}
                                class="thumbnail"
                                width="1600"
                                height="1600"
                            />
                            {product.alternateImageUrl && (
                                <img
                                    srcset={`${product.alternateImageUrl}?width=165 165w,
                                            ${product.alternateImageUrl}?width=360 360w,
                                            ${product.alternateImageUrl}?width=533 533w,
                                            ${product.alternateImageUrl}?width=720 720w,
                                            ${product.alternateImageUrl}?width=940 940w,
                                            ${product.alternateImageUrl}?width=1066 1066w,
                                            ${product.alternateImageUrl} 1600w`}
                                    src={`${product.alternateImageUrl}?width=533`}
                                    sizes="(min-width: 1920px) 447px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"
                                    alt=""
                                    class="motion-reduce thumbnail-hover"
                                    loading="lazy"
                                    width="1600"
                                    height="1600"
                                />
                            )}
                        </div>
                    </div>
                    <div class="card__content card__content-new">Card Content</div>
                </div>
                <div class="card__information-wrapper">
                    <div class="card__information card__information-new">
                        <div class="card-swatches">
                            {hasVariants && <SwatchSelector product={product} onImageChange={setCurrentImage} />}
                        </div>
                        <h3 class="card__heading H-18">
                            {name}
                        </h3>
                        {subheading && <p class="H-16-alt card__subheading">{subheading}</p>}
                        <div class="card-information">
                            <div class="price price-new">
                                <div class="price__container">
                                    <div class="price__regular price__regular-new">
                                        <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                        <span class="price-item price-item--regular H-16">
                                            <span class="from-text P-12">from</span> {format(product.price)}
                                        </span>
                                    </div>
                                    <div class="price__sale">
                                        <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                        <span class="P-12">
                                            <s class="price-item price-item--regular"></s>
                                        </span>
                                        <span class="visually-hidden visually-hidden--inline">Sale price</span>
                                        <span class="price-item price-item--sale price-item--last H-16">
                                            From {format(product.price)}
                                        </span>
                                    </div>
                                    <small class="unit-price caption hidden">
                                        <span class="visually-hidden">Unit price</span>
                                        <span class="price-item price-item--last">
                                            <span></span>
                                            <span aria-hidden="true">/</span>
                                            <span class="visually-hidden">&nbsp;per&nbsp;</span>
                                            <span></span>
                                        </span>
                                    </small>
                                </div>
                            </div>
                        </div>
                        {product?.ratingValue > 0 && product?.reviewCount && (
                            <div class="star-rating">
                                <StarRating rating={product?.ratingValue} reviewCount={product?.reviewCount} />
                            </div>
                        )}
                    </div>
                </div>
            </SerpElement>
            {tags.length > 0 && (
                <div class="sc-badge sc-badge-red product-card-badge">
                    {tags.map(v => (
                        <p class={v.class}>{v.label}</p>
                    ))}
                </div>
            )}
        </div>
    )
}
